<template>
  <div>
    <div
      class="containall d-flex flex-column h-100"
      onload="init()"
      data-aos-easing="ease"
      data-aos-duration="400"
      data-aos-delay="0"
      style="padding-right: 21px"
    >
      <div
        data-aos="fade-right"
        class="contentmain boxcolor aos-init aos-animate"
      >
        <div class="headmain"></div>
        <div class="containmoney">
          <table width="100%">
            <tbody>
              <tr>
                <td width="50%" style="padding-left: 0px; padding-bottom: 10px">
                  <img src="./../assets/image/logo.gif" class="img-fluid" />
                </td>
                <td width="50%" style="text-align: right">
                  <span style="font-size: 17px; color: #000; font-weight: 800">
                    <i class="fas fa-coin"></i> ยอดเครดิตของคุณ
                  </span>
                  <br />
                  <span style="color: #000; font-size: 35px; font-weight: 900">
                    <i
                      id="bal_loader"
                      class="fas fa-spinner fa-pulse fa-spin m-2"
                    ></i>
                    <span id="balance" style="">{{
                      UserInfo.Credit | formatNumber
                    }}</span>
                    <span style="font-size: 15px"> บาท</span>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="row">
            <div class="col col-md-6 mb-1">
              <button @click="ComingSoon()" class="btn btnfriend bkcolor w-100">
                <i class="fas fa-donate" aria-hidden="true"></i> เติมเครดิต
              </button>
            </div>
            <div class="col col-md-6 mb-1">
              <button
                data-bs-toggle="modal"
                data-bs-target="#modalwithdraw"
                class="btn btncommis btn-success w-100"
              >
                <i class="fas fa-baht-sign" aria-hidden="true"></i> ถอนเครดิต
              </button>
            </div>
            <div class="col col-md-6 mb-1">
              <button
                data-bs-toggle="modal"
                data-bs-target="#modalsettings"
                class="btn btnfriend btn-primary w-100"
              >
                <i class="fas fa-gear" aria-hidden="true"></i> ตั้งค่าระบบ
              </button>
            </div>
            <div class="col col-md-6 mb-1">
              <router-link to="/login"
                ><button class="btn btncommis logoutbtn w-100">
                  <i class="fas fa-power-off" aria-hidden="true"></i>
                  ออกจากระบบ
                </button></router-link
              >
            </div>
          </div>
        </div>
        <div style="display: block" class="containuserinfo text-center">
          <span style="font-size: 17px" id="userdata"
            >demouser , หมดอายุในอีก 7 นาที</span
          >
        </div>
        <div style="display: none" class="containuserinfo text-center bg-red">
          <span style="font-size: 17px" id="userdata">คงเหลือ 0 วัน</span>
        </div>
        <div id="content_loader" class="text-center mt-4" style="display: none">
          <h1><i class="fas fa-spinner fa-pulse fa-spin"></i></h1>
        </div>
        <div id="topup" style="display: none">
          <div class="headerprocess" style="padding-top: 5px">
            <i class="fal fa-gamepad-alt"></i> กรุณาชำระค่าบริการ
          </div>
          <div class="containprocess text-center" style="padding: 5px 10px">
            <span style="font-size: 16px"
              >ติดต่อชำระค่าบริการได้ที่ Line ID :
              <a style="font-size: 18px" href="https://lin.ee/6a9H25M"
                >@947lttey</a
              ></span
            >
            <br />
            <span style="font-size: 20px">หรือสแกน QRCODE</span>
            <br />
            <br />
            <a href="https://lin.ee/6a9H25M"
              ><img
                src="https://qr-official.line.me/sid/M/947lttey.png?shortenUrl=true"
            /></a>
          </div>
        </div>
        <div id="pg_game" style="">
          <div
            @click="goBack()"
            class="headerprocess2"
            v-if="data.ProviderCode != -1"
            style="color: red; padding-top: 5px"
          >
            <i class="fa-solid fa-arrow-left"></i> ย้อนกลับ
          </div>
          <div class="headerprocess" style="padding-top: 5px">
            <i class="fal fa-gamepad-alt"></i>
            <span
              v-text="
                data.ProviderCode == -1
                  ? 'เลือกค่ายที่ต้องการ'
                  : 'เลือกเกมที่ต้องการ'
              "
            ></span>
          </div>
          <div class="containprocess" style="padding: 0 10px">
            <div class="container">
              <div
                v-if="data.ProviderCode == -1"
                class="row justify-content-center mt-3"
              >
                <div
                  v-bind:key="i"
                  v-for="(data, i) in data.Provider"
                  v-on:click="getGameList(data.ProviderCode, data.mode)"
                  class="col-auto col-3 mb-3"
                >
                  <div class="card-game box-shadow-3">
                    <div class="card-body p-0 text-center">
                      <img
                        :title="data.ProviderName"
                        class="img-fluid rounded img-game btn-play-game"
                        v-bind:src="data.ImgUrl"
                        @error="imageLoadError"
                      />
                      <div class="justify-content-md-center mt-1">
                        <span
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          :title="data.ProviderName"
                          style="font-size: 14px"
                          class="mt-1 mb-0 gamename"
                          >{{ data.ProviderName }}</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="row justify-content-center mt-3">
                <div
                  v-bind:key="i"
                  v-for="(data, i) in data.GameList"
                  class="col-auto col-3 mb-3"
                >
                  <div class="card-game box-shadow-3">
                    <div class="card-body p-0 text-center">
                      <img
                        v-on:click="StartGame(data.gameCode, data.mode)"
                        :title="data.gameName"
                        class="img-fluid rounded img-game btn-play-game"
                        v-bind:src="data.imgUrl"
                        @error="imageLoadError"
                      />
                      <div class="justify-content-md-center mt-1">
                        <span
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          :title="data.gameName"
                          style="font-size: 14px"
                          class="mt-1 mb-0 gamename"
                          >{{ data.gameName }}</span
                        >
                        <div v-if="data.gameCode == 'b'" class="d-grid mt-1">
                          <button
                            @click="getSetting()"
                            id="btn_game_setting"
                            data-game="btrfly-blossom"
                            class="btn btn-warning btn-sm"
                          >
                            <i class="fas fa-cog"></i> ตั้งค่า
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
<div class="modal fade" id="modalsettings" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="ModalSettings" aria-hidden="true">
<div class="modal-dialog modal-dialog-centered text-light">
<div class="modal-content">
<div class="modal-header">
<h5 class="modal-title text-light fw-bold" id="ModalSettings"><i class="fas fa-gear" aria-hidden="true"></i> รวมเมนูตั้งค่า</h5>
<button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
</div>
<div class="modal-body">
<div class="row text-center justify-content-center">
<div class="col-lg-12 ps-3 pe-3 mb-2">
 <div class="row">
<div class="col-6 justify-content-start text-start"><span class="fw-bold fs-5">ซ่อน / แสดง ปุ่มตั้งค่า</span></div>
<div class="col-6 justify-content-end text-end">
<div class="form-switch form-switch-md">
<input class="form-check-input " type="checkbox" id="switch_config">
</div>
</div>
</div>
</div>
<hr />
<div class="col-lg-12 ps-3 pe-3 mb-2">
<span class="fw-bold fs-5">ตั้งค่าบัญชีรับเงิน (จำลอง)</span><br>
<small class="fw-bold text-danger p-0 mb-2">ระบบจะส่งข้อความทาง SMS อ่านวิธีใช้ก่อน !</small>
<button id="btnwithdrawhowto" class="btn bth-sm btn-danger"><i class="fas fa-piggy-bank" aria-hidden="true"></i> วิธีใช้</button>
<div class="ps-4 pe-4 mt-1 text-start">
<label for="bankname">ธนาคาร (แสดงผล) <small class="fw-bold text-danger p-0 m-0">*ช่วงทดลองใช้ได้แค่ KBANK</small></label>
<div class="iconlogin">
<i class="fal fas fa-university" style="font-size: 17px"></i>
</div>
<select id="bankname" class="sebank form-control">
<option value="" selected>เลือก ธนาคาร</option>
<option disabled value="scb">ธนาคารไทยพาณิชย์ จำกัด (มหาชน)</option>
<option disabled value="bbl">ธนาคารกรุงเทพ จำกัด (มหาชน)</option>
<option value="kbank">ธนาคารกสิกรไทย จำกัด (มหาชน)</option>
<option disabled value="ktb">ธนาคารกรุงไทย จำกัด (มหาชน)</option>
<option disabled value="ttb">ธนาคารทหารไทยธนชาต จำกัด (มหาชน)</option>
<option disabled value="bay">ธนาคารกรุงศรีฯ จำกัด (มหาชน)</option>
<option disabled value="gsb">ธนาคารออมสิน จำกัด (มหาชน)</option>
<option disabled value="baac">ธนาคารเพื่อการเกษตรและสหกรณ์ จำกัด (มหาชน)</option>
<option disabled value="tisco">ธนาคารทิสโก้ จำกัด (มหาชน)</option>
<option disabled value="uob">ธนาคารยูโอบี จำกัด (มหาชน)</option>
<option disabled value="citi">ธนาคารซิตี้แบงก์ จำกัด (มหาชน)</option>
<option disabled value="deut">ธนาคารดอยช์แบงก์ จำกัด (มหาชน)</option>
 </select>
</div>
<div class="ps-4 pe-4 text-start">
<label for="bankaccname">ชื่อบัญชี (แสดงผล)</label>
<div class="iconlogin">
<i class="fal fas fa-chess-queen" style="font-size: 17px"></i>
</div>
<input type="text" class="form-control sebank" id="bankaccname" placeholder="กรอกชื่อบัญชี">
<label for="bankaccnum">หมายเลขบัญชี (แสดงผล)</label>
<div class="iconlogin">
<i class="fal fas fa-piggy-bank" style="font-size: 17px"></i>
</div>
<input type="text" onkeypress="return onlyNumberKey(event)" class="form-control sebank" id="bankaccnum" placeholder="กรอกหมายเลขบัญชี ">
<label for="bankacctel">เบอร์มือถือ (รับ SMS)</label>
<div class="iconlogin">
<i class="fal fas fa-phone-volume" style="font-size: 17px"></i>
</div>
<input type="text" onkeypress="return onlyNumberKey(event)" maxlength="10" class="form-control sebank" id="bankacctel" placeholder="กรอกเบอร์มือถือ ">
<label for="bankbalance">ยอดคงเหลือ (แสดงใน SMS)</label>
<div class="iconlogin">
<i class="fal fas fa-coins" style="font-size: 17px"></i>
</div>
<input type="text" onkeypress="return onlyNumberKey(event)" maxlength="8" class="form-control sebank" id="bankbalance" placeholder="กรอกยอดคงเหลือ ">
<div class="d-grid gap-2 mt-2 mb-2">
<button id="savebankdata" class="btn btn-success w-100"><i class="fa-solid fa-window-restore"></i> บันทึกข้อมูลบัญชีรับเงิน</button>
</div>
</div>
</div>
<hr />
<div class="col-lg-12 ps-3 pe-3 mb-2">
<div class="row">
<div class="col col-sm-6">
<div class="d-grid gap-2 mt-1">
<button id="clearhistorybtn" class="btn btn-primary w-100"><i class="fas fa-trash-alt"></i> ล้างประวัติการเล่นทั้งหมด</button>
</div>
</div>
<div class="col col-sm-6">
<div class="d-grid gap-2 mt-1">
<button id="resetconfigbtn" class="btn btn-warning  w-100"><i class="fa-solid fa-window-restore"></i> รีเซ็ตการตั้งค่าเกมทั้งหมด</button>
</div>
</div>
</div>
</div> 
</div>
</div>
<div class="modal-footer">
<button type="button" class="btn btn-danger btn-sm" data-bs-dismiss="modal">ปิดหน้านี้</button>
</div>
</div>
</div>
</div>
<div class="modal fade" id="modalwithdraw" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="ModalWithdraw" aria-hidden="true">
<div class="modal-dialog modal-dialog-centered text-light">
<div class="modal-content">
<div class="modal-header">
<h5 class="modal-title text-light fw-bold" id="ModalWithdraw"><i class="fas fa-baht-sign" aria-hidden="true"></i> แจ้งถอนเงิน</h5>
<button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
</div>
<div class="modal-body">
<div id="withdraw" class="row ps-4 pe-4">
<div class="col-8 text-left align-self-center">
<span style="font-size: 20px; font-weight: bold;">ถอนเงินเข้าบัญชี</span> <br>
<span style="font-weight: bold;">userName : </span> <span id="wdbankaccname">{{ UserInfo.Username }}</span><br>
<span style="font-weight: bold;">เลขที่บัญชี : </span> <span id="wdbankaccnum"><i class="fa-solid fa-spinner fa-spin-pulse"></i></span><br>
<span style="font-weight: bold;">ธนาคาร : </span> <span id="wdbank"><i class="fa-solid fa-spinner fa-spin-pulse"></i></span>
</div>
<div class="col-4 text-center align-self-center">
<img id="banklogo" src="" style="padding: 5%;border-radius: 18px;" width="70px">
</div>
<div style="color: #ffd714" class="wdsec02 col-12 text-center align-self-center mt-3">
<div class="row p-1">
<div class="col-6 align-self-center">
จำนวนเงินที่ถอนได้<br />
<span style="font-weight: bold; font: 1em;" id="withdraw_balance">฿ 0.00</span>
</div>
<div class="col-6 align-self-center">
ยอดถอนขั้นต่ำ<br />
<span style="font-weight: bold; font: 1em;">฿ 300.00 </span>
</div>
</div>
</div>
<div class="col-12 mt-3">
<div class="form-group">
<span style="font-size: 15px;">
จำนวนเงินที่ต้องการถอน
</span>
<input autocapitalize="off" maxlength="12" type="text" id="in-money-wd" onkeypress="return onlyNumberKey(event)" class="form-control wdf" placeholder="฿ 0.00" style="padding: 10px; margin-top: 10px;text-align: center;">
</div>
</div>
<div class="col-12 mt-3">
<div class="d-grid gap-2 mt-2 mb-2">
<button id="wd-money" class="btn btn-warning w-100"><i class="fa-solid  fa-hand-holding-usd"></i> ยืนยันการถอน</button>
 </div>
</div>
</div>
</div>
<div class="modal-footer">
<button type="button" class="btn btn-danger btn-sm" data-bs-dismiss="modal">ปิดหน้านี้</button>
</div>
</div>
</div>
</div>
<div class="modal fade" id="modalwithdrawhowto" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="ModalWithdrawHowTo" aria-hidden="true">
<div class="modal-dialog modal-dialog-centered text-light">
<div class="modal-content">
<div class="modal-header">
<h5 class="modal-title text-light fw-bold" id="ModalWithdraw"><i class="fas fa-piggy-bank" aria-hidden="true"></i> วิธีใช้งานระบบถอนเงิน</h5>
<button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
</div>
<div class="modal-body text-center">
<h1 class="text-danger fw-bold mt-1">อ่านก่อน</h1>
<p class="text-warning fw-bold">ระบบนี้เป็นระบบจำลองว่าได้ถอนเงินเข้าบัญชีธนาคาร โดยระบบจะส่ง SMS ไปยังหมายเลขเบอร์โทรศัพท์ของลูกค้า จริง ๆ แต่เนื่องจากเบอร์ของระบบเราเป็นหมายเลข 06X ลูกค้าต้อง "บันทึกเบอร์" ของระบบเราเองและตั้งชื่อ เบอร์ของระบบเราเป็น ชื่อที่เหมือนกับธนาคาร ด้วยตนเอง</p>
<p class="text-danger fw-bold">เนื่องจากเป็นช่วงทดลองใช้งานจริง<br />ตอนนี้ใช้งานได้เพียง ธนาคารกสิกรไทย เท่านั้น</p>
<hr />
<h3>เพิ่มรายชื่อผู้ติดต่อ หมายเลข</h3>
<input type="text" value="097-507-0163" class="text-center form-control form-control-lg" readonly>
<br />
<h3>และบันทึกผู้ติดต่อเป็นชื่อ</h3>
<input type="text" value="KBank" class="text-center form-control form-control-lg" readonly>
<br />
<h5 class="text-danger fw-bold mt-1">แนะนำให้ใช้งานผ่านโทรศัพท์ที่ใช้ระบบปฏิบัติการ iOS หรือ Android ที่ไม่เห็นเบอร์ฯ ตอนแสดงผล SMS<br>ตัวอย่างด้านล่าง</h5>
<img class="img-fluid rounded" src="https://www.img.in.th/images/d99a873e55b591ac831c296de20491be.jpg" alt="ตัวอย่างด้านล่าง" />
<br />
<p class="text-danger fw-bold mb-2">ข้อความอาจส่งช้า / เร็ว แต่ไม่เกิน 5 นาทีหลังจากทำรายการจำกัด 15 ครั้งต่อ 1 วัน ไม่ควรกดถอนเงินรัวหาก SMS ไม่เข้าให้เว้นช่วง 30 นาที ถึง 1 ชั่วโมงหาก SMS ไม่เข้าค่อยถอนใหม่</p>
 <br />
<h3>พบปัญหา หรือ แนะนำ ขอเพิ่มธนาคาร แจ้งที่แอดมินในไลน์ได้เลย</h3>
</div>
<div class="modal-footer">
<button type="button" class="btn btn-danger btn-sm" data-bs-dismiss="modal">ปิดหน้านี้</button>
</div>
</div>
</div>
</div>
    <div
      class="modal fade"
      id="modal_gameconfig"
      tabindex="-1"
      aria-labelledby="exampleModalCenterTitle"
      style="display: none"
      aria-hidden="true"
    >
      <div
        class="
          modal-dialog
          modal-dialog-centered
          modal-dialog-centered
          modal-dialog-scrollable
        "
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-dark" id="gameConfigTitle">
              ตั้งค่าเกม Fortune Tiger
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <form id="form_savegameconfig">
              <input
                type="hidden"
                value="fortune-tiger"
                id="game"
                name="game"
              />
              <div class="form-group">
                <div class="row justify-content-center">
                  <div class="col-lg-12 text-center">
                    <div class="row">
                      <div class="col-lg-12 mb-2 text-left">
                        <div class="table-responsive">
                          <table
                            id="gameConfigTable2"
                            class="table table-bordered mb-0 text-center"
                          >
                            <thead>
                              <tr>
                                <th>NAME</th>
                                <th>
                                  PROBABILITY (<span id="countProb">100</span>)
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <th>ไม่แตก</th>
                                <th>
                                  <input
                                    style="
                                      text-align: center;
                                      font-weight: bold;
                                    "
                                    min="0"
                                    max="100"
                                    data-id="0"
                                    name="data[0][spin][probability]"
                                    type="number"
                                    class="form-control probability2"
                                    value="45"
                                  />
                                </th>
                              </tr>
                              <tr>
                                <th>แตกน้อย</th>
                                <th>
                                  <input
                                    style="
                                      text-align: center;
                                      font-weight: bold;
                                    "
                                    min="0"
                                    max="100"
                                    data-id="1"
                                    name="data[1][spin][probability]"
                                    type="number"
                                    class="form-control probability2"
                                    value="32"
                                  />
                                </th>
                              </tr>
                              <tr>
                                <th>แตกหนัก</th>
                                <th>
                                  <input
                                    style="
                                      text-align: center;
                                      font-weight: bold;
                                    "
                                    min="0"
                                    max="100"
                                    data-id="2"
                                    name="data[2][spin][probability]"
                                    type="number"
                                    class="form-control probability2"
                                    value="4"
                                  />
                                </th>
                              </tr>
                              <tr>
                                <th>แตกหนักมาก</th>
                                <th>
                                  <input
                                    style="
                                      text-align: center;
                                      font-weight: bold;
                                    "
                                    min="0"
                                    max="100"
                                    data-id="3"
                                    name="data[3][spin][probability]"
                                    type="number"
                                    class="form-control probability2"
                                    value="6"
                                  />
                                </th>
                              </tr>
                              <tr>
                                <th>เสือเกือบโดด</th>
                                <th>
                                  <input
                                    style="
                                      text-align: center;
                                      font-weight: bold;
                                    "
                                    min="0"
                                    max="100"
                                    data-id="4"
                                    name="data[4][spin][probability]"
                                    type="number"
                                    class="form-control probability2"
                                    value="7"
                                  />
                                </th>
                              </tr>
                              <tr>
                                <th>เสือเกือบโดดแตกน้อย</th>
                                <th>
                                  <input
                                    style="
                                      text-align: center;
                                      font-weight: bold;
                                    "
                                    min="0"
                                    max="100"
                                    data-id="5"
                                    name="data[5][spin][probability]"
                                    type="number"
                                    class="form-control probability2"
                                    value="0"
                                  />
                                </th>
                              </tr>
                              <tr>
                                <th>เสือเกือบโดดแตกหนัก</th>
                                <th>
                                  <input
                                    style="
                                      text-align: center;
                                      font-weight: bold;
                                    "
                                    min="0"
                                    max="100"
                                    data-id="6"
                                    name="data[6][spin][probability]"
                                    type="number"
                                    class="form-control probability2"
                                    value="0"
                                  />
                                </th>
                              </tr>
                              <tr>
                                <th>เสือโดดแตกน้อย</th>
                                <th>
                                  <input
                                    style="
                                      text-align: center;
                                      font-weight: bold;
                                    "
                                    min="0"
                                    max="100"
                                    data-id="7"
                                    name="data[7][spin][probability]"
                                    type="number"
                                    class="form-control probability2"
                                    value="1"
                                  />
                                </th>
                              </tr>
                              <tr>
                                <th>เสือโดดแตกหนัก</th>
                                <th>
                                  <input
                                    style="
                                      text-align: center;
                                      font-weight: bold;
                                    "
                                    min="0"
                                    max="100"
                                    data-id="8"
                                    name="data[8][spin][probability]"
                                    type="number"
                                    class="form-control probability2"
                                    value="2"
                                  />
                                </th>
                              </tr>
                              <tr>
                                <th>เสือโดดแตกหนักมาก</th>
                                <th>
                                  <input
                                    style="
                                      text-align: center;
                                      font-weight: bold;
                                    "
                                    min="0"
                                    max="100"
                                    data-id="9"
                                    name="data[9][spin][probability]"
                                    type="number"
                                    class="form-control probability2"
                                    value="3"
                                  />
                                </th>
                              </tr>
                              <tr>
                                <th>test</th>
                                <th>
                                  <input
                                    style="
                                      text-align: center;
                                      font-weight: bold;
                                    "
                                    min="0"
                                    max="100"
                                    data-id="99"
                                    name="data[99][spin][probability]"
                                    type="number"
                                    class="form-control probability2"
                                    value="0"
                                  />
                                </th>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div id="feature_table" class="col-lg-12 mb-2 text-left">
                        <div class="table-responsive">
                          <table
                            id="gameConfigTable3"
                            class="table table-bordered mb-0 text-center"
                            style="display: none"
                          >
                            <thead>
                              <tr>
                                <th>NAME</th>
                                <th>
                                  PROBABILITY (<span id="countProb3">0</span>)
                                </th>
                              </tr>
                            </thead>
                            <tbody></tbody>
                          </table>
                        </div>
                      </div>
                      <div class="col-lg-12">
                        <button
                          type="submit"
                          id="btn_agenteditsave"
                          code-id=""
                          class="btn btn-success btn-block"
                        >
                          <i class="far fa-save"></i> บันทึกข้อมูล
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-dark" data-bs-dismiss="modal">
              <i class="bx bx-x"></i>
              <span>ปิดหน้านี้</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="heightmobile"></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
//import Modal from './../components/Modal.vue'
import { CheckSession } from "./../mixins/CheckSession.js";
import config from "./../config/index.js";
import api from "./../services/index.js";
export default {
  name: "Home",
  components: {
    /*Modal*/
  },
  mixins: [CheckSession],
  data() {
    return {
      //isModalVisible: false,
      data: {
        ProviderCode: -1,
        Provider: [],
        GameList: [],
      },
    };
  },
  computed: {
    ...mapGetters(["getAccessToken"]),
  },
  mounted() {
    this.getProvider();
  },
  methods: {
    showModal() {
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    async getProvider() {
      await api
        .get("/GameList")
        .then((v) => {
          if (v.status.code == 200) {
            this.data.Provider = v.data.txnList;
          } else if (v.status.code == 400) {
            this.$router.push("/login");
            this.$swal.fire("แจ้งเตือน", v.status.message, "error");
          } else {
            this.$swal.fire("แจ้งเตือน", v.status.message, "error");
          }
        })
        .catch((e) => {
          if (e.status.code == 400) {
            this.$router.push("/login");
            this.$swal.fire("แจ้งเตือน", e.status.message, "error");
          } else {
            this.$swal.fire("แจ้งเตือน", e.status.message, "error");
          }
        });
    },
    async getGameList(ProviderCode, Mode) {
      if (Mode != 1) {
        return;
      }
      await api
        .get(`/GameList/${ProviderCode}`)
        .then((v) => {
          if (v.status.code == 200) {
            this.data.ProviderCode = ProviderCode;
            this.data.GameList = v.data.txnList;
          } else if (v.status.code == 400) {
            this.$router.push("/login");
            this.$swal.fire("แจ้งเตือน", v.status.message, "error");
          } else {
            this.$swal.fire("แจ้งเตือน", v.status.message, "error");
          }
        })
        .catch((e) => {
          if (e.status.code == 400) {
            this.$router.push("/login");
            this.$swal.fire("แจ้งเตือน", e.status.message, "error");
          } else {
            this.$swal.fire("แจ้งเตือน", e.status.message, "error");
          }
        });
    },
    async StartGame(gameCode, Mode) {
      if (Mode != 1) {
        return;
      }
      await api
        .post("/v2/play", {
          provider: this.CryptoJS.AES.encrypt(
            this.data.ProviderCode,
            config.Crypto_Secret
          ).toString(),
          gameCode: this.CryptoJS.AES.encrypt(
            gameCode,
            config.Crypto_Secret
          ).toString(),
        })
        .then((v) => {
          if (v.status.code == 200) {
            setTimeout("location.href = '" + v.data.login_url + "';", 100);
          } else if (v.status.code == 400) {
            this.$router.push("/login");
            this.$swal.fire("แจ้งเตือน", v.status.message, "error");
          } else {
            this.$swal.fire("แจ้งเตือน", v.status.message, "error");
          }
        })
        .catch((e) => {
          if (e.status.code == 400) {
            this.$router.push("/login");
            this.$swal.fire("แจ้งเตือน", e.status.message, "error");
          } else {
            this.$swal.fire("แจ้งเตือน", e.status.message, "error");
          }
        });
    },
    async getSetting() {
      this.$swal.fire(
        //"เรียบร้อยแล้ว",
        //"อัพเดทเครดิตเรียบร้อยแล้ว!",
        "ระบบนี้ยังไม่เปิดใช้งาน",
        "",
        "error"
      );
    },
    async ComingSoon() {
      this.$swal.fire(
        //"เรียบร้อยแล้ว",
        //"อัพเดทเครดิตเรียบร้อยแล้ว!",
        "ระบบนี้ยังไม่เปิดใช้งาน",
        "",
        "error"
      );
    },
    async addCredit() {
      this.$swal.fire({
        title: "กรุณารอสักครู่...",
        timerProgressBar: true,
        allowOutsideClick: false,
        didOpen: () => {
          //this.$swal.showLoading();
        },
      });
      this.$swal.fire({
        title: "แก้ไขเครดิตของคุณ",
        input: "text",
        inputValue: this.UserInfo.Credit.toFixed(2),
        inputAttributes: {
          autocapitalize: "off",
          inputPlaceholder: "กรุณาใส่จำนวนเครดิตที่ต้องการ",
        },
        showCancelButton: true,
        cancelButtonText: "ยกเลิก",
        confirmButtonText: "บันทึกข้อมูล",
        showLoaderOnConfirm: true,
        preConfirm: (value) => {
          this.$swal.fire({
            title: "กรุณารอสักครู่...",
            timerProgressBar: true,
            allowOutsideClick: false,
            didOpen: () => {
              //this.$swal.showLoading();
            },
          });
          console.log(value);
          // axios
          this.$swal.fire(
            //"เรียบร้อยแล้ว",
            //"อัพเดทเครดิตเรียบร้อยแล้ว!",
            "ระบบนี้ยังไม่เปิดใช้งาน",
            "",
            "error"
          );
        },
        allowOutsideClick: () => !this.$swal.isLoading(),
      });
    },
    async goBack() {
      await this.getProvider();
      this.data.ProviderCode = -1;
    },
    imageLoadError(e) {
      e.target.src =
        "https://cdn.askmebet.cloud//img/slot_202006301524292929.png";
    },
  },
};
</script>
<style scope>
.divComing_soon {
  position: absolute;
  right: 0;
  bottom: 0;
  background: #414141;
  z-index: 1;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
  width: 100%;
  overflow: hidden;
}

.txtComing_soon {
  font-size: 13px;
  color: #f5f900;
  padding: 3px 5px 0;
}

.Coming_soon .image {
  opacity: 0.5;
}

.Coming_soon a {
  cursor: no-drop;
}
</style>